<template>
  <slot
    :openEditor="openEditor"
    :isDocumentationState="isDocumentationState"
  />

  <Button
    v-if="isDocumentationState && !$slots.default"
    type="button"
    label="Inserisci documentazione"
    icon="pi pi-file-edit"
    @click="openEditor"
  />

  <Dialog
    v-model:visible="visible"
    modal
    maximizable
    header="Invio documentazione"
    :style="{ width: '85vw' }"
    :breakpoints="{ '1199px': '90vw', '575px': '96vw' }"
  >
    <p class="mt-0 mb-3">
      Inserisci il testo relativo alla documentazione da inviare.
    </p>

    <Editor
      v-model="content"
      editorStyle="height: 450px"
      placeholder="Scrivi il testo della documentazione..."
    >
      <template #toolbar>
        <span class="ql-formats">
          <select class="ql-size">
            <option
              v-for="size in fontSizes"
              :key="size"
              :value="size"
              :selected="size === defaultFontSize"
            >
              {{ size }}
            </option>
          </select>
        </span>
        <span class="ql-formats">
          <button class="ql-bold"></button>
          <button class="ql-italic"></button>
          <button class="ql-underline"></button>
          <button class="ql-strike"></button>
        </span>
        <span class="ql-formats">
          <select class="ql-color"></select>
          <select class="ql-background"></select>
        </span>
        <span class="ql-formats">
          <button class="ql-list" value="ordered"></button>
          <button class="ql-list" value="bullet"></button>
          <button class="ql-align" value=""></button>
          <button class="ql-align" value="center"></button>
          <button class="ql-align" value="right"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-link"></button>
          <button class="ql-clean"></button>
        </span>
      </template>
    </Editor>

    <template #footer>
      <Button
        type="button"
        label="Annulla"
        icon="pi pi-times"
        class="p-button-text"
        @click="visible = false"
      />
      <Button
        type="button"
        label="Salva testo"
        icon="pi pi-check"
        :disabled="!hasContent"
        @click="submit"
      />
    </template>
  </Dialog>
</template>

<script>
import { computed, ref, watch } from "vue";
import Editor from "primevue/editor";
import Quill from "quill";

const FONT_SIZES = Array.from(
  { length: 13 },
  (_, index) => `${8 + index * 2}px`
);
const DEFAULT_FONT_SIZE = "14px";
const SizeStyle = Quill.import("attributors/style/size");

SizeStyle.whitelist = FONT_SIZES;
Quill.register(SizeStyle, true);

export default {
  name: "NotaInvioDocumentazione",
  components: {
    Editor,
  },
  props: {
    pratica: {
      type: Object,
      default: null,
    },
    modelValue: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const visible = ref(false);
    const content = ref("");

    const isDocumentationState = computed(() => {
      const statusName = String(props.pratica?.selectedStato?.stato || "")
        .trim()
        .toLowerCase();

      return statusName === "invio documentazione";
    });

    const hasContent = computed(() => {
      const plainText = content.value
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/g, " ")
        .trim();

      return plainText.length > 0;
    });

    const openEditor = () => {
      content.value = props.modelValue || "";
      visible.value = true;
    };

    const submit = () => {
      if (!hasContent.value) {
        return;
      }

      emit("update:modelValue", content.value);
      visible.value = false;
    };

    watch(isDocumentationState, (isActive) => {
      if (!isActive) {
        visible.value = false;
      }
    });

    return {
      visible,
      content,
      fontSizes: FONT_SIZES,
      defaultFontSize: DEFAULT_FONT_SIZE,
      isDocumentationState,
      hasContent,
      openEditor,
      submit,
    };
  },
};
</script>
